{
  "actions": "Åtgärder",
  "actionsAvailable": "Åtgärder finns.",
  "clearSelection": "Rensa markering",
  "selected": "{count, plural, =0 {Inga valda} one {# vald} other {# valda}}",
  "selectedAll": "Alla markerade"
}
